const ItemImage = ({ item }) => {
	return (
		<img
			height="24"
			width="24"
			src={`./assets/items/${item.id}.gif`}
			alt={item.name}
		/>
	);
};

export default ItemImage;
